// extracted by mini-css-extract-plugin
export var Card = "style-module--Card--3Q7GQ";
export var Banner = "style-module--Banner--1nkoD";
export var ImageWrapper = "style-module--ImageWrapper--xPcZW";
export var Image = "style-module--Image--2Iuuo";
export var DescriptionWrapper = "style-module--DescriptionWrapper--3dqr_";
export var Category = "style-module--Category--1Y0OB";
export var Title = "style-module--Title--2aVEu";
export var Details = "style-module--Details--34YMO";
export var ReadingTime = "style-module--ReadingTime--1VwUB";